import { Modal, type ModalProps } from '@mntn-dev/ui-components'

type NotificationModalProps = ModalProps

const NotificationModal = ({ children, ...props }: NotificationModalProps) => (
  <Modal {...props} variant="unpositioned" overlayClassName="backdrop-blur-sm">
    {children}
  </Modal>
)

export { NotificationModal, type NotificationModalProps }
